import React, { useEffect, useState } from 'react';
import Headers from '../Components/Common/Header';
import LoginForm from '../Components/Pages/Login/LoginForm';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { fetchUserData, logout } from '../Helpers/userSlice';
import useCheckUserToken from "../Helpers/Common";
import Loader from '../Components/Common/Loader';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated, isLoading } = useSelector((state) => state.user);
  const accessToken = localStorage.getItem('NCProAccessToken');
  const refreshToken = localStorage.getItem('NCProRefreshToken');
  const { isExpired } = useCheckUserToken(accessToken);

  const [authCheckLoading, setAuthCheckLoading] = useState(true);

  useEffect(() => {
    const refreshTokenAndFetchUserData = async () => {
      if (isExpired) {
        if (refreshToken) {
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_BACKEND_BASE_URL}/user/refresh-token`,
              {
                headers: {
                  Authorization: `Bearer ${refreshToken}`,
                },
              }
            );
            const newAccessToken = response.data.accessToken;
            localStorage.setItem('NCProAccessToken', newAccessToken);
            dispatch(fetchUserData(newAccessToken));
          } catch (error) {
            console.error('Error refreshing token:', error);
            if (error.response.data.errorDetails.message === 'jwt expired') {
              localStorage.removeItem('NCProAccessToken');
              localStorage.removeItem('NCProRefreshToken');
            }
            dispatch(logout());
            navigate('/login');
          }
        }
      } else {
        if (accessToken) {
          dispatch(fetchUserData(accessToken));
          navigate('/ncpro/welcome');
        } else{
          setAuthCheckLoading(false);
        }
      }
      setAuthCheckLoading(false);
    };

    if (!isAuthenticated) {
      refreshTokenAndFetchUserData();
    } else {
      navigate('/ncpro/welcome');
      setAuthCheckLoading(false);
    }
  }, [isAuthenticated, accessToken, refreshToken, isExpired, dispatch, navigate]);

  if (authCheckLoading || isLoading) {
    return (
      <Loader /> // Later, will handle this as a common component in Redux
    );
  }

  return (
    <>
      {!isAuthenticated ? (
        <>
          <Headers />
          <LoginForm />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
